import { get, post, put, destroy, patch } from "./_utils";
import axios from "axios";

// gets all the forms
export const getForms = (params = {}, controller = new AbortController()) => {
  return axios.get("/forms.json", { params, signal: controller.signal });
};

// gets the details for a new form
export const getNewForm = () => {
  return get("/forms/new.json");
};

// get all the details regarding the given form
export const getFormDetails = (id, published) => {
  return get(`/forms/${id}/edit.json`, { published });
};

// get filtered form data: fields should be array of column name (snake case)
// eg: ['name', 'created_at']
export const getLimitedFormDetails = (id, fields) => {
  return get(`/forms/${id}.json`, { fields });
};

// create a form with given params
export const createForm = (data, params = {}) => {
  return post(`/forms.json`, data, params);
};

// update an existing form
export const updateForm = (id, data) => {
  return put(`/forms/${id}.json`, data);
};

// destroy a given form
export const deleteForm = (id) => {
  return destroy(`/forms/${id}.json`);
};

// clone a given form
export const cloneForm = (id) => {
  return post(`/forms/${id}/clone.json`);
};

// toggle form status
export const toggleFormStatus = (id, params = {}) => {
  return patch(`/forms/${id}/publish_or_unpublish.json`, params);
};

// partial update form
export const partialUpdateForm = (id, data) => {
  return patch(`/forms/${id}.json`, data);
};

// sends a submission with form id and current user email
// requesting our support in creating form
export const getSupport = (url, data) => {
  return post(url, data);
};

// get survey from details regarding the given form
export const getFormSurveyDetails = (id, params = {}) => {
  return get(`/f/${id}.json`, params);
};

// update last viewed submission time
export const updateLastViewedSubmission = (id) => {
  return get(`/forms/${id}/update_submission_last_viewed_at.json`);
};

// Aggregating submission data for form
export const getAggregatedSubmissionData = (formId) => {
  return get(`/forms/${formId}/aggregate_submission_data.json`);
};

// Get all versions for a form
export const getFormVersions = (formId) => {
  return get(`/forms/${formId}/versions.json`);
};

// Delete a version
export const deleteFormVersion = (formId, versionId) => {
  return destroy(`/forms/${formId}/versions/${versionId}.json`);
};

// Restore a specific version
export const restoreFormVersion = (formId, versionId) => {
  return post(`/forms/${formId}/versions/${versionId}/restore.json`);
};

// generate ai rules a given form
export const generateAiRules = (id, params = {}) => {
  return post(`/forms/${id}/generate_ai_rules.json`, params);
};

export const emailSurveyLink = (id, data) => {
  return post(`/f/${id}/email_survey_link`, data);
};

export const formCreationStatus = (processId) => {
  return get(`/forms/creation/${processId}.json`);
};

// Get all predefined prompts
export const getPredefinedPrompts = () => {
  return get("/predefined_prompts.json");
};

// AI Form Editor Prompt request -> process_id
export const getAiEditorProcessId = (formId, params) => {
  return post(`/forms/${formId}/ai_editor`, params);
};

export const getAiEditorProcessData = (formId, process_id) => {
  return get(`/forms/${formId}/poll_ai_editor`, { process_id });
};
